export default {
    SELECT_PAYMENT: '[TAKE PAYMENT] SELECT_PAYMENT',
    CANCEL_PAYMENT: '[TAKE PAYMENT] CANCEL_PAYMENT',
    BACK_TO_ADD_PAYMENT: '[TAKE PAYMENT] BACK_TO_ADD_PAYMENT',
    BACK_PAYMENT: '[TAKE PAYMENT] BACK_PAYMENT',
    SWITCH_PAGE: '[TAKE PAYMENT] SWITCH_PAGE',
    RESET_STATE: '[TAKE PAYMENT] RESET_STATE',
    ADD_PAYMENT: '[TAKE PAYMENT] ADD_PAYMENT',

    PAYMENT_PAGE_SELECT_PAYMENT: '[TAKE PAYMENT] PAYMENT_PAGE_SELECT_PAYMENT',
    PAYMENT_PAGE_EDIT_PAYMENT: '[TAKE PAYMENT] PAYMENT_PAGE_EDIT_PAYMENT',
    PAYMENT_PAGE_COMPLETE_PAYMENT: '[TAKE PAYMENT] PAYMENT_PAGE_COMPLETE_PAYMENT',

    PAYMENT_TYPE_OFFLINE: '0',
    PAYMENT_TYPE_CREDITCARD_FORM: '1',
    PAYMENT_TYPE_REDIRECT: '2',

    PAYMENT_IS_REFERENCE_NUMBER: 1,
    PAYMENT_CAN_DUE: 1,
}


// WEBPACK FOOTER //
// ./src/view/constant/order/TakePaymentConstant.js